import { render } from "./FrisbuyGalleryPagination.vue?vue&type=template&id=abfc5564&scoped=true"
import script from "./FrisbuyGalleryPagination.vue?vue&type=script&lang=js"
export * from "./FrisbuyGalleryPagination.vue?vue&type=script&lang=js"

import "./FrisbuyGalleryPagination.vue?vue&type=style&index=0&id=abfc5564&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abfc5564"]])

export default __exports__